var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.719,
    y1: -0.281,
    x2: -0.877,
    y2: 1.526,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4a849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3b221"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.5 16.5H16.5V4.5H4.5V16.5ZM7.5 7.5H13.5V13.5H7.5V7.5ZM4.5 31.5H16.5V19.5H4.5V31.5ZM7.5 22.5H13.5V28.5H7.5V22.5ZM19.5 4.5V16.5H31.5V4.5H19.5ZM28.5 13.5H22.5V7.5H28.5V13.5ZM28.5 28.5H31.5V31.5H28.5V28.5ZM19.5 19.5H22.5V22.5H19.5V19.5ZM22.5 22.5H25.5V25.5H22.5V22.5ZM19.5 25.5H22.5V28.5H19.5V25.5ZM22.5 28.5H25.5V31.5H22.5V28.5ZM25.5 25.5H28.5V28.5H25.5V25.5ZM25.5 19.5H28.5V22.5H25.5V19.5ZM28.5 22.5H31.5V25.5H28.5V22.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.6868d2edf486b765041774077e040d72.svg";
export { ForwardRef as ReactComponent };